import { useV2ListTagsForAccountQuery } from "@generated";

export interface TagOption {
  label: string;
  value: string;
}

const useListTagsForAccount = () => {
  let customError: string | null = null;

  const { data, error, isLoading, refetch, isFetching } =
    useV2ListTagsForAccountQuery({});

  let tags: TagOption[] = [];

  if (data?.data) {
    try {
      tags = data.data.map((tag) => {
        if (!tag.id) throw new Error("Missing tag.id");
        if (!tag.attributes?.name)
          throw new Error("Missing tag.attributes.name");

        return {
          value: tag.attributes.name,
          label: tag.attributes.name,
        };
      });
    } catch (err) {
      customError =
        err instanceof Error ? err.message : "An unknown error occurred";
    }
  }

  return {
    tags,
    tagsLoading: isLoading,
    tagsFetching: isFetching,
    error: error ?? customError,
    refetch,
  };
};

export default useListTagsForAccount;
